import { IIconProps } from "../types"

export default function IconUL4(props: IIconProps) {
  const width = props.size || props.width || 74
  const height = props.size || props.height || 87
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 74 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.0713 1.53303C43.3213 0.82303 40.1313 0.49303 36.8813 0.98303C33.6213 1.47303 30.3013 2.77303 27.4713 5.08303C24.6413 7.39303 22.2913 10.713 19.9813 14.033C17.6713 17.353 15.3913 20.673 13.0813 24.453C10.7713 28.233 8.43133 32.463 6.64133 35.973C4.85133 39.493 3.61133 42.293 2.66133 44.833C1.72133 47.373 1.07133 49.643 0.841333 51.833C0.611333 54.013 0.811333 56.093 1.49133 58.243C2.18133 60.393 3.35133 62.603 5.43133 65.373C7.52133 68.133 10.5113 71.453 14.1913 74.773C17.8713 78.093 22.2313 81.423 25.4213 83.473C28.6113 85.523 30.6313 86.303 34.0113 86.173C37.4013 86.043 42.1513 85.003 46.7713 83.563C51.4013 82.133 55.8913 80.313 59.7913 77.573C63.7013 74.843 67.0213 71.193 69.1413 68.233C71.2513 65.273 72.1613 62.993 72.3913 57.953C72.6213 52.903 72.1613 45.093 71.0913 37.243C70.0213 29.403 68.3213 21.523 66.2713 16.053C64.2213 10.583 61.8113 7.52303 58.4613 5.44303C55.1113 3.36303 50.8113 2.25303 47.0713 1.53303Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
